import './styles.css';

const RoomInfo = ({ room, isMobile, onClick }) => {
  const Component = isMobile ? 'button' : 'div';
  const className = isMobile ? 'room-info-mobile' : 'room-info';
  
  return (
    <Component 
      className={className}
      onClick={isMobile ? () => onClick?.(room) : undefined}
    >
      <img src={room.image} alt={room.name} className="room-image" />
      <div className="room-image-text">
        <h3>{room.name}</h3>
      </div>
    </Component>
  );
};

export default RoomInfo;